export default Object.freeze({
  PLACED: 'PLACED',
  EDITABLE: 'EDITABLE',
  EDIT_MODE: 'EDIT_MODE',
  IN_WAREHOUSE: 'IN_WAREHOUSE',
  TRAILER_LOADING: 'TRAILER_LOADING',
  TRUNKING: 'TRUNKING',
  MARSHALLING: 'MARSHALLING',
  ON_ROUTE: 'ON_ROUTE',
  ATTEMPTING_REDELIVERY: 'ATTEMPTING_REDELIVERY',
  DELIVERED: 'DELIVERED',
  DELIVERY_FAILED: 'DELIVERY_FAILED',
  SCRATCHED: 'SCRATCHED',
  CANCELLED: 'CANCELLED',
  LATE_CANCEL: 'LATE_CANCEL',
});
